import React from 'react'

const AppContainer = ({ children }) => (
  <div className="App contrast">{children}</div>
)

export default AppContainer
